wrapHook